
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class StarryNightEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const size = (2 + (config.parallaxLayers - layerIndex) * 2) * (config.parallaxScale || 1.0);

        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        ctx.fillStyle = pc.color;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x * 1.5 + y * 0.7 + layerIndex) * spacing;
                const offY = this.pseudoRandom(y * 1.2 + x * 0.9 + layerIndex) * spacing;
                const s = size * (0.5 + this.pseudoRandom(x + y) * 0.5);
                
                const draw = () => {
                    ctx.beginPath();
                    ctx.arc(x + offX, y + offY, s, 0, Math.PI * 2);
                    ctx.fill();
                };

                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
